import React from "react";
import { Link } from "react-router-dom";
import { LogoName } from "../../Utility/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import "./UniversalHeader.css";


const UniversalHeader = () => {
  const role = localStorage.getItem("Role")?.toUpperCase();

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("Role");
    localStorage.removeItem("userID");
    sessionStorage.removeItem("TeacherDashboardGreeting")
    sessionStorage.removeItem("dashboardGreeting")
    sessionStorage.removeItem("StudentDashboardGreeting")
    window.location.href = "/";
  };

  // --------- Redirect Logo based on Role ---------
  const getHomeLink = () => {
    switch (role) {
      case "SUPERADMIN": return "/superadmindashboard";
      case "ADMIN": return "/admindashboard";
      case "TEACHER": return "/teachers-landing";
      case "STUDENT": return "/manage-personal-student";
      case "EXAMHEAD": return "/examhead-landing";
      case "RECEPTIONIST": return "/manage-reception-dashboard";
      default: return "/";
    }
  };

  // --------- MENUS BASED ON ROLE ---------
  const renderMenu = () => {
    switch (role) {

      // ---------------- SUPER ADMIN ----------------
      case "SUPERADMIN":
        return (
          <>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="manage-admin"
                id="manageMastersDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ color: "white" }}
              >
                Manage Masters
              </a>
              <div
                className="dropdown-menu bg-dark"
                aria-labelledby="manageMastersDropdown"
              >
                <Link className="dropdown-item" to="/manage-caste">
                  Caste
                </Link>
                <Link className="dropdown-item" to="/manage-category">
                  Category
                </Link>
                <Link className="dropdown-item" to="/manage-state">
                  State
                </Link>
                <Link className="dropdown-item" to="/manage-school-medium">
                  School Medium
                </Link>
                <Link className="dropdown-item" to="/manage-district">
                  District
                </Link>
                <Link className="dropdown-item" to="/manage-taluka">
                  Taluka
                </Link>
                <Link className="dropdown-item" to="/manage-city">
                  City-Vlllage
                </Link>
                <Link className="dropdown-item" to="/manage-stream">
                  Stream
                </Link>
                <Link className="dropdown-item" to="/manage-session">
                  Session
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="manageSchoolDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ color: "white" }}
              >
                Manage School
              </a>
              <div
                className="dropdown-menu bg-dark"
                aria-labelledby="manageSchoolDropdown"
              >
                <Link className="dropdown-item" to="/school-list">
                  School Registration Details
                </Link>
                <Link className="dropdown-item" to="/manage-standard">
                  Standard
                </Link>
                <Link className="dropdown-item" to="/manage-school-session-mapping">
                  School Session Mapping
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown">
              <Link
                className="nav-link"
                to="/manage-admin"
                style={{ color: "white" }}
              >
                Manage Admin
              </Link>
            </li>
          </>
        );

      // ---------------- ADMIN ----------------
      case "ADMIN":
        return (
          <>
            {/* ---------------- Manage School ---------------- */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="manageSchoolDropdown"
                role="button"
                data-toggle="dropdown"
                style={{ color: "white" }}
              >
                Manage School
              </a>
              <div className="dropdown-menu bg-dark">
                <Link className="dropdown-item" to="/school-list">
                  School Registration Details
                </Link>
                <Link className="dropdown-item" to="/manage-section">
                  Section
                </Link>
              </div>
            </li>

            {/* ---------------- Manage Masters ---------------- */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="manageMastersDropdown"
                role="button"
                data-toggle="dropdown"
                style={{ color: "white" }}
              >
                Manage Masters
              </a>

              <div className="dropdown-menu bg-dark">

                <h6 className="dropdown-header text-warning">
                  Subject Management
                </h6>

                {/* <Link className="dropdown-item" to="/teacher-class-subject-mapping">
                  Subject Mapping
                </Link> */}

                <Link className="dropdown-item" to="/manage-subject-category-master">
                  Subject Category Master
                </Link>

                <Link className="dropdown-item" to="/manage-subject-category-config">
                  Subject Category Configuration
                </Link>

                <Link className="dropdown-item" to="/manage-subject">
                  Subject Master
                </Link>

                <div className="dropdown-divider"></div>

                <h6 className="dropdown-header text-warning">
                  Certificate Masters
                </h6>

                <Link className="dropdown-item" to="/manage-conduct-master">
                  LC Conduct Master
                </Link>

                <Link className="dropdown-item" to="/manage-progress-master">
                  LC Progress Master
                </Link>

                <Link className="dropdown-item" to="/manage-reason-master">
                  LC Reason Master
                </Link>

                <Link className="dropdown-item" to="/manage-remark-master">
                  LC Remark Master
                </Link>

                <Link className="dropdown-item" to="/manage-bonafide-reason-master">
                  Bonafide Reason Master
                </Link>

                <Link className="dropdown-item" to="/manage-early-remarks-master">
                  Early Release Remark Master
                </Link>

                <div className="dropdown-divider"></div>

                <h6 className="dropdown-header text-warning">
                  Other Masters
                </h6>

                <Link className="dropdown-item" to="/manage-disability-master">
                  Disability Type Master
                </Link>

                <Link className="dropdown-item" to="/manage-holiday-master">
                  Holiday Master
                </Link>

                <Link className="dropdown-item" to="/manage-caste">
                  Caste
                </Link>
                <Link className="dropdown-item" to="/manage-category">
                  Category
                </Link>
                <Link className="dropdown-item" to="/manage-state">
                  State
                </Link>
                <Link className="dropdown-item" to="/manage-district">
                  District
                </Link>
                <Link className="dropdown-item" to="/manage-taluka">
                  Taluka
                </Link>
                <Link className="dropdown-item" to="/manage-city">
                  City-Vlllage
                </Link>
                <Link className="dropdown-item" to="/manage-stream">
                  Stream
                </Link>

              </div>
            </li>

            {/* ---------------- Manage Users ---------------- */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="manageUsersDropdown"
                role="button"
                data-toggle="dropdown"
                style={{ color: "white" }}
              >
                Manage Users
              </a>

              <div className="dropdown-menu bg-dark">
                <Link className="dropdown-item" to="/manage-teachers">
                  Add Users
                </Link>

                <Link
                  className="dropdown-item"
                  to="/teacher-class-subject-mapping"
                >
                  Map Class & Subject
                </Link>
              </div>
            </li>

            {/* ---------------- Manage Students ---------------- */}
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/manage-student"
                style={{ color: "white" }}
              >
                Manage Students
              </Link>
            </li>

            {/* ---------------- Manage Reports ---------------- */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="manageReportsDropdown"
                role="button"
                data-toggle="dropdown"
                style={{ color: "white" }}
              >
                Manage Reports
              </a>

              <div className="dropdown-menu bg-dark">

                <h6 className="dropdown-header text-warning">
                  Certificates
                </h6>

                <Link className="dropdown-item" to="/manage-reports">
                  Manage Certificates
                </Link>

                <Link className="dropdown-item" to="/lc-tracking-master">
                  LC Tracking Master
                </Link>

                <div className="dropdown-divider"></div>

                <h6 className="dropdown-header text-warning">
                  SARAL
                </h6>

                <Link className="dropdown-item" to="/manage-AadhaarReport">
                  Aadhaar Report
                </Link>

                <div className="dropdown-divider"></div>

                <h6 className="dropdown-header text-warning">
                  UDISE+
                </h6>

                <Link className="dropdown-item" to="/manage-UDISEImportReport">
                  UDISE Import
                </Link>

                <Link
                  className="dropdown-item"
                  to="/manage-UDISEProfileUpdationReport"
                >
                  UDISE Profile
                </Link>

                <Link className="dropdown-item" to="/manage-ApaarIdReport">
                  APAAR ID
                </Link>

                <div className="dropdown-divider"></div>

                <h6 className="dropdown-header text-warning">
                  Other Reports
                </h6>

                <Link className="dropdown-item" to="/manage-AdmissionSourceReport">
                  Admission Source
                </Link>

                <Link className="dropdown-item" to="/manage-BoardWiseReport">
                  Boardwise Report
                </Link>

                <Link className="dropdown-item" to="/manage-CategoryWiseReport">
                  Categorywise Report
                </Link>

                <Link className="dropdown-item" to="/manage-GenderwiseReport">
                  Genderwise Report
                </Link>

                <Link className="dropdown-item" to="/student-reg-details">
                  Student Reg. Details
                </Link>

                <Link className="dropdown-item" to="/staff-reg-details">
                  Staff Reg. Details
                </Link>

                <Link className="dropdown-item" to="/student-id-cards">
                  ID Cards
                </Link>

              </div>
            </li>
          </>
        );

      // ---------------- TEACHER ----------------
      case "TEACHER":
        return (
          <>
            {
              localStorage.getItem("Role") === "TEACHER" && localStorage.getItem("IsClassTeacher") === 'true'
              &&
              <>
                {/* ---------------- Manage Mappings ---------------- */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="examDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    My Details
                  </a>

                  <div className="dropdown-menu bg-dark">

                    <Link className="dropdown-item" to="/manage-teachers">
                      Update Profile
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/teacher-class-subject-mapping"
                    >
                      Map Class & Subject
                    </Link>

                  </div>
                </li>

                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="manageMappingsDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    Manage Mappings
                  </a>

                  <div className="dropdown-menu bg-dark">
                    <Link
                      className="dropdown-item"
                      to="/number-mapping-master"
                    >
                      Number Mapping
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/mark-lc-details-mappings"
                    >
                      LC Mapping
                    </Link>

                  </div>
                </li>

                {/* ---------------- Manage Students ---------------- */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/manage-student"
                    style={{ color: "white" }}
                  >
                    Manage Students
                  </Link>
                </li>

                {/* ---------------- Manage Attendance ---------------- */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="attendanceDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    Manage Attendance
                  </a>

                  <div className="dropdown-menu bg-dark">

                    <Link
                      className="dropdown-item"
                      to="/mark-attendance"
                    >
                      Attendance Master
                    </Link>

                    <span className="dropdown-item-text text-warning">
                      Reports
                    </span>

                    <Link
                      className="dropdown-item"
                      to="/view-attendance"
                    >
                      Catalog
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="#"
                    >
                      Yearly Report
                    </Link>

                  </div>
                </li>

                {/* ---------------- Manage Examination ---------------- */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="examDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    Manage Examination
                  </a>

                  <div className="dropdown-menu bg-dark">

                    <Link
                      className="dropdown-item"
                      to="/manage-marks-feeding"
                    >
                      Manage Marks
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/view-marks-feeding"
                    >
                      Update Marks
                    </Link>

                    <div className="dropdown-divider"></div>

                    <span className="dropdown-item-text text-warning">
                      Reports
                    </span>

                    <Link
                      className="dropdown-item"
                      to="/summary-report"
                    >
                      Summary Report
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/result-summary-report"
                    >
                      Result Summary Report
                    </Link>

                    <div className="dropdown-divider"></div>

                    <Link
                      className="dropdown-item"
                      to="/grace-marks-feeding"
                    >
                      Grace Mark Feeding
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/report-card"
                    >
                      Report Card
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/overall-annual-exam-report"
                    >
                      Overall Annual Exam Report
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/category-wise-annual-exam-report"
                    >
                      Category Wise Annual Exam Report
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/subject-and-teacher-wise-annual-exam-report"
                    >
                      Subject And Teacher Wise Annual Exam Report
                    </Link>

                    <Link className="dropdown-item" to="/student-reg-details">
                      Student Reg. Details
                    </Link>

                    <Link className="dropdown-item" to="/student-id-cards">
                      ID Cards
                    </Link>

                  </div>
                </li>
              </>
            }
            {
              localStorage.getItem("Role") === "TEACHER" && localStorage.getItem("IsClassTeacher") !== 'true'
              &&
              <>
                {/* ---------------- Manage Examination ---------------- */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="examDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    My Details
                  </a>

                  <div className="dropdown-menu bg-dark">

                    <Link className="dropdown-item" to="/manage-teachers">
                      Update Profile
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/teacher-class-subject-mapping"
                    >
                      Map Class & Subject
                    </Link>

                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="examDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: "white" }}
                  >
                    Manage Examination
                  </a>

                  <div className="dropdown-menu bg-dark">

                    <Link
                      className="dropdown-item"
                      to="/manage-marks-feeding"
                    >
                      Manage Marks
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="/view-marks-feeding"
                    >
                      Update Marks
                    </Link>

                    <div className="dropdown-divider"></div>

                    <span className="dropdown-item-text text-warning">
                      Reports
                    </span>

                    <Link
                      className="dropdown-item"
                      to="/summary-report"
                    >
                      Summary Report
                    </Link>

                  </div>
                </li>

              </>
            }
          </>
        );

      // ---------------- STUDENT ----------------
      case "STUDENT":
        return (
          <>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/manage-student"
                style={{ color: "white" }}
              >
                My Details
              </Link>
            </li>
            <li className="nav-item dropdown">
              <Link
                to="/student-profile"
                className="nav-link"
                style={{ color: "white" }}
              >
                Manage Profile
              </Link>
              <div
                className="dropdown-menu bg-dark"
                aria-labelledby="manageMastersDropdown"
              ></div>
            </li>
          </>
        );

      // ---------------- EXAM HEAD ----------------
      case "EXAMHEAD":
        return (
          <>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
                Manage Masters
              </a>
              <div className="dropdown-menu bg-dark">
                <Link className="dropdown-item" to="/mark-master">Mark Master</Link>
                <Link className="dropdown-item" to="/grade-master">Grade Master</Link>
              </div>
            </li>
          </>
        );

      // ---------------- RECEPTIONIST ----------------
      case "RECEPTIONIST":
        return (
          <>
            <li className="nav-item">
              <Link className="nav-link" to="/manage-inquiry">Manage Inquiry</Link>
            </li>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container d-flex justify-content-between">

          {/* Logo */}
          <a className="navbar-brand" href={getHomeLink()}>{LogoName}</a>
          {/* <a className="navbar-brand" href={getHomeLink()}>{
            useSchoolData()?.schoolInfo?.schoolOrCollegeName
            }</a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENUS */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">{renderMenu()}</ul>
          </div>

          {/* PROFILE + LOGOUT */}
          <div className="d-flex align-items-center">
            <Link
              to={
                role === "Receptionist"
                  ? "/student-profile"
                  : "/profile"
              }
              className="text-light me-3"
            >
              <FontAwesomeIcon icon={faUserCircle} size="2x" />
            </Link>

            <button className="btn btn-outline-light" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default UniversalHeader;
